import React from "react";
import config from "../../../config/enviroment";
import Button from "../../Ui/Button/index";
var OopsInfo = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement(React.Fragment, null,
        React.createElement("img", { src: config.urlS3 + "/wom/info/oops.png", alt: "error" }),
        React.createElement("h2", null, "\u00A1Oops! Ocurri\u00F3 un error"),
        React.createElement("p", null,
            "En este momento presentamos intermitencia temporal en nuestro portal para pagos, por favor ingresa nuevamente en unos minutos.",
            " "),
        React.createElement("div", { className: "button-container-errormodal" },
            React.createElement(Button, { onClick: function () { onClick(); } }, "REINTENTAR"))));
};
export default OopsInfo;
